<template>
  <div class="resita">
    <h1>Reschitza, Reşiţa</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/bana_1kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Süden"
        @click="callImageClick('Reschitza, Reşiţa: Süden', 'bana_1.jpg', $event)">
						<br>Reschitza, Reşiţa: Süden
      </div>
      <div class="foto">
        <img src="../assets/fotos/resc_1kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: evangelische Kirche, Stahlwerk"
        @click="callImageClick('Reschitza, Reşiţa: evangelische Kirche, Stahlwerk', 'resc_1.jpg', $event)">
						<br>Reschitza, Reşiţa: evangelische Kirche, Stahlwerk
      </div>
      <div class="foto">
        <img src="../assets/fotos/resc_3kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Wasserausgabe nach Überschwemmungen 1997"
        @click="callImageClick('Reschitza, Reşiţa: Wasserausgabe nach Überschwemmungen 1997', 'resc_3.jpg', $event)">
						<br>Reschitza, Reşiţa: Wasserausgabe nach Überschwemmungen 1997
      </div>
      <div class="foto">
        <img src="../assets/fotos/resc_5kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: orthodoxe Kirche"
        @click="callImageClick('Reschitza, Reşiţa: orthodoxe Kirche', 'resc_5.jpg', $event)">
						<br>Reschitza, Reşiţa: orthodoxe Kirche
      </div>
      <div class="foto">
        <img src="../assets/fotos/resc_6kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Denkmal der Deportation der Banater Berglanddeutschen nach Rußland 1945"
        @click="callImageClick('Reschitza, Reşiţa: Denkmal der Deportation der Banater Berglanddeutschen nach Rußland 1945', 'resc_6.jpg', $event)">
						<br>Reschitza, Reşiţa: Denkmal der Deportation der Banater Berglanddeutschen nach Rußland 1945
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Busbf_kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Busbahnhof, autogara"
        @click="callImageClick('Reschitza, Reşiţa: Busbahnhof, autogara', 'Res_Busbf.jpg', $event)">
						<br>Reschitza, Reşiţa: Busbahnhof, autogara
      </div>
      <div class="foto">
        <img src="../assets/fotos/Res_Tramdepot_kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Busbahnhof, autogara"
        @click="callImageClick('Reschitza, Reşiţa: Busbahnhof, autogara', 'Res_Tramdepot.jpg', $event)">
						<br>Reschitza, Reşiţa: Tramdepot
      </div>
      <div class="foto">
        <img src="../assets/fotos/seme_1kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: beim Semenic"
        @click="callImageClick('Reschitza, Reşiţa: beim Semenic', 'seme_1.jpg', $event)">
						<br>Reschitza, Reşiţa: beim Semenic
      </div>
      <div class="foto">
        <img src="../assets/fotos/seme_2kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: beim Semenic"
        @click="callImageClick('Reschitza, Reşiţa: beim Semenic', 'seme_2.jpg', $event)">
						<br>Reschitza, Reşiţa: beim Semenic
      </div>
      <div class="foto">
        <img src="../assets/fotos/seme_3kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: beim Semenic"
        @click="callImageClick('Reschitza, Reşiţa: beim Semenic', 'seme_3.jpg', $event)">
						<br>Reschitza, Reşiţa: beim Semenic
      </div>
      <div class="foto">
        <img src="../assets/fotos/wolf_1kl.jpg" width="125" border="0" height="110" alt="Gărâna, Wolfsberg"
        @click="callImageClick('Gărâna, Wolfsberg', 'wolf_1.jpg', $event)">
						<br>Gărâna, Wolfsberg
      </div>
      <div class="foto">
        <img src="../assets/fotos/wolf_2kl.jpg" width="125" border="0" height="110" alt="Gărâna, Wolfsberg"
        @click="callImageClick('Gărâna, Wolfsberg', 'wolf_2.jpg', $event)">
						<br> bei Gărâna, Wolfsberg
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>